import jQuery from 'jquery';
import { diffusionServiceUtils } from 'rp-prices-component';
import DiffusionSession from 'rp-diffusion-connector';

export default class TextCommentaries {
    constructor(textCommentaries) {
        const defaultConfig = {
            session: {
                onDataFunction: this.onDataReceive.bind(this)
            },
            selectors: {
                commentContainer: '.RC-textCommentaries_comment',
                resultContainer: '.RC-textCommentaries_result',
                commentariesWrapper: '.RC-textCommentaries'
            },
            classes: {
                block: 'RC-textCommentaries__block',
                blockTitle: 'RC-textCommentaries__blockTitle',
                blockRow: 'RC-textCommentaries__blockRow',
                hiddenSection: 'RC-textCommentaries__section_hidden'
            },
            bottomSpace: 220
        };
        const pageConfigElement = jQuery('.js-diffusionTopicSettingsRace')[0];
        this.config = jQuery.extend(true, defaultConfig, textCommentaries);

        this.topicsReceived = [];
        this.lastRenderedIndexComments = -1;
        this.session = new DiffusionSession(this.config.session);
        this.raceType = diffusionServiceUtils.getTopicRaceType();
        this.raceDate = diffusionServiceUtils.getTopicRaceDate(pageConfigElement);
        this.courseName = diffusionServiceUtils.getTopicCourseName(pageConfigElement);
        this.raceTime = diffusionServiceUtils.getTopicRaceTime(pageConfigElement);
        this.typeComments = diffusionServiceUtils.getTopicMarketType('COMMENTS');
        this.typeResultText = diffusionServiceUtils.getTopicMarketType('RESULTSTEXT');
        this.subscribe();
    }

    subscribe() {
        const commentsTopic = [
            this.raceType,
            this.raceDate,
            this.courseName,
            this.raceTime,
            this.typeComments].join('/');
        const resultTextTopic = [
            this.raceType,
            this.raceDate,
            this.courseName,
            this.raceTime,
            this.typeResultText].join('/');
        const topics = [resultTextTopic, commentsTopic];
        this.session.subscribe({ topics });
    }

    onDataReceive(WebClientMessage) {
        let isFullResult = true;
        const records = WebClientMessage.getRecords();

        this.topicsReceived.push(WebClientMessage.getTopic().split('/')[4]);

        if (this.isCommentsType(WebClientMessage)) {
            this.renderCommentaries(records);
        } else {
            this.renderResult(records);
            isFullResult = records.some(record => (record[0].indexOf('ran') !== -1));
        }

        if (!this.topicsReceived.includes('RESULTSTEXT') || !isFullResult) {
            this.scrollToFocus();
        }
    }

    scrollToFocus() {
        const $window = jQuery(window);
        const wrapper = jQuery(this.config.selectors.commentariesWrapper);
        const bottomPosition = wrapper.offset().top
            + wrapper.outerHeight()
            + this.config.bottomSpace;
        const scrollBottom = $window.scrollTop() + $window.height();

        if (bottomPosition > scrollBottom) {
            $window.scrollTop(bottomPosition - $window.height());
        }
    }

    renderCommentaries(records) {
        const newRecords = records.slice(this.lastRenderedIndexComments + 1);

        newRecords.forEach(record =>
            this.renderMessage(this.parseRecord(record), this.config.selectors.commentContainer));
        this.lastRenderedIndexComments = records.length - 1;
        jQuery(this.config.selectors.commentContainer)
            .removeClass(this.config.classes.hiddenSection);
    }

    renderResult(records) {
        jQuery(`${this.config.selectors.resultContainer} .${this.config.classes.block}`).remove();
        records.forEach(record =>
            this.renderMessage(this.parseRecord(record), this.config.selectors.resultContainer));
        jQuery(this.config.selectors.resultContainer)
            .removeClass(this.config.classes.hiddenSection);
    }

    parseRecord(record) {
        // temporary solution for exceptional chars combination Â´
        const specialCharsRegex = /(\u00c2(\u00b4|\u0091|\u0092|\u0093|\u0095|\u0082))/g;
        const text = record[0].replace(specialCharsRegex, "'");

        // temporary solution for exceptional chars combination Â£
        const pricesRegex = /([\u00c2\u00a0])/g;
        const pureText = text.replace(pricesRegex, '');

        const message = {
            isNewBlock: false,
            text: pureText
        };
        const headerRegex = /(<([^>]+)>)/ig;
        const textRegex = /<\/?(?:(?!b\b)[^>])*>/ig;

        if (message.text.indexOf('<f18>') !== -1) {
            message.isNewBlock = true;
            message.text = message.text.replace(headerRegex, '').trim();
        }
        if (message.text === 'at the post') {
            message.isNewBlock = true;
        }
        if (message.isNewBlock) {
            return message;
        }
        message.text = message.text.replace(textRegex, '').replace('<B>', '<b>').replace('</B>', '</b>').trim();

        return message;
    }

    isCommentsType(WebClientMessage) {
        return WebClientMessage.getTopic().split('/')[4] === 'COMMENTS';
    }

    renderMessage(message, containerSelector) {
        if (!message.text) {
            return;
        }
        if (message.isNewBlock) {
            const title = jQuery('<span></span>').addClass(this.config.classes.blockTitle).html(message.text);
            const block = jQuery('<div></div>').addClass(this.config.classes.block).append(title);

            jQuery(containerSelector).append(block);
        } else {
            const row = jQuery('<div></div>').addClass(this.config.classes.blockRow).html(message.text);
            const lastBlockSelector = `${containerSelector} .${this.config.classes.block}:last-child`;

            jQuery(lastBlockSelector).append(row);
        }
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/textCommentaries/textCommentaries.js